import React, { useState } from 'react';
import { ResolvePublicAppointmentActionAPI } from '../../../../api/API';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CheckIcon from '@mui/icons-material/Check';
import PatientItem from '../shared/PatientItem';
import IconAction from '../shared/IconAction';
import styles from './ActionCenter.module.css';

const WEEKDAYS = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
const MONTHS = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

/** "Quinta, 02 de julho" */
function formatDate(isoDate) {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  const dd = String(dt.getDate()).padStart(2, '0');
  return `${WEEKDAYS[dt.getDay()]}, ${dd} de ${MONTHS[dt.getMonth()]}`;
}

function buildWhatsappMessage(item) {
  const name = item.patient?.name || 'Paciente';
  const firstName = name.split(' ')[0];
  const date = formatDate(item.appointment?.date);
  const time = item.appointment?.time || '';

  if (item.action === 'reschedule') {
    return `Olá ${firstName}, vimos que você solicitou o reagendamento da sua consulta em ${date} às ${time}. Vamos combinar um novo horário?`;
  }
  return `Olá ${firstName}, vimos que você solicitou o cancelamento da sua consulta em ${date} às ${time}. Podemos confirmar o cancelamento?`;
}

/** Pedido feito pelo paciente no link público (reagendar ou cancelar). */
function PendingRequestItem({ item, onResolved }) {
  const [resolving, setResolving] = useState(false);

  const isReschedule = item.action === 'reschedule';
  const patientPhone = item.patient?.phone || '';
  const hasPhone = patientPhone.length >= 8;
  const date = formatDate(item.appointment?.date);
  const time = item.appointment?.time || '';
  const when = `${date}${time ? ` às ${time}` : ''}`;

  function handleWhatsApp() {
    // O telefone já vem do backend com o código do país, então vai direto no link
    const url = `https://api.whatsapp.com/send?phone=${patientPhone}&text=${encodeURIComponent(buildWhatsappMessage(item))}`;
    window.open(url, '_blank', 'noreferrer');
  }

  function handleViewAppointment() {
    const apptDate = item.appointment?.date;
    if (apptDate) window.open(`/schedule/appointments?date=${apptDate}`, '_blank');
  }

  function handleResolve() {
    setResolving(true);
    ResolvePublicAppointmentActionAPI(item.id, (res) => {
      setResolving(false);
      if (res && res.status === 'success') {
        onResolved(item.id);
      } else {
        alert('Não foi possível marcar como resolvido. Tente novamente.');
      }
    });
  }

  return (
    <PatientItem
      name={item.patient?.name || 'Paciente'}
      patientId={item.patient?.id}
      tone={isReschedule ? 'amber' : 'red'}
      meta={(
        <>
          <span className={isReschedule ? styles.tagReschedule : styles.tagCancel}>
            {isReschedule ? 'Quer reagendar' : 'Quer cancelar'}
          </span>
          {' '}{[when, item.professional?.name, item.appointment?.procedure_name].filter(Boolean).join(' · ')}
        </>
      )}
      actions={(
        <>
          {hasPhone && (
            <IconAction title="Conversar no WhatsApp" onClick={handleWhatsApp} tone="whatsapp">
              <WhatsAppIcon style={{ fontSize: 17 }} />
            </IconAction>
          )}
          <IconAction title="Ver na agenda" onClick={handleViewAppointment}>
            <CalendarTodayOutlinedIcon style={{ fontSize: 15 }} />
          </IconAction>
          <IconAction title={resolving ? 'Resolvendo…' : 'Marcar como resolvido'} onClick={handleResolve} tone="success" disabled={resolving}>
            <CheckIcon style={{ fontSize: 17 }} />
          </IconAction>
        </>
      )}
    />
  );
}

export default PendingRequestItem;
